<template>
	<div>
		<template v-if="headerShow">
			<div class="sqzxOne">
				<!-- @click="goClickOne(index)" -->
				<div class="sqzxOneFor" v-for="(item,index) in itema.child" :key="index">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
					<div class="sqzxOneForXian" v-if="index!==shfwOne.length-1">
						<div></div>
					</div>
				</div>
			</div>
			<div class="fwys">
				<div class="fwysTil">{{$t('i18n_51')}}</div>
				<div class="fwysBox">
					<div class="fwysBoxFor" v-for="(item,index) in fwysList" :key="index">
						<div class="fwysBoxForImg">
							<img :src="item.cover" />
						</div>
						<div class="fwysBoxForName">
							{{item.title}}
						</div>
						<div class="fwysBoxForCen">
							{{item.desc}}
						</div>
					</div>
				</div>
			</div>
			<div class="cjfk">
				<div class="cjfkTil">
					{{$t('i18n_52')}}
				</div>
				<div class="cjfkBox">
					<div class="cjfkBoxFor" v-for="(item,index) in cjfkList" :key="index" @click="item.show=!item.show"
						:style="{
					height:item.show?'300px':'82px'
					}">
						<div class="cjfkBoxForTil">
							<div class="cjfkBoxForTilWz">{{item.question}}</div>
							<div class="cjfkBoxForTilIcon">
								<i class="el-icon-arrow-up" v-if="item.show"></i>
								<i class="el-icon-arrow-down" v-else></i>
							</div>
						</div>
						<div class="cjfkBoxForCen" v-if="item.show">
							{{item.answer}}
						</div>
					</div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_53')}}</div>
				<div class="gjfwXl" @click="gnShow=!gnShow">
					<div class="gjfwXlName" v-if="gnList.length>0">
						{{gnList[gnSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gnShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gnShow">
						<div class="gjfwXlDwFor" :class="gnSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gnList"
							:key="index" @click.stop="goGnfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gnDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gnDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_54')}}：{{gnDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_55')}}：{{gnDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gnDetail.cover" v-if="gnDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />

					</div>
				</div>
			</div>
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{$t('i18n_56')}}</div>
				<div class="gjfwXl" @click="gjShow=!gjShow">
					<div class="gjfwXlName" v-if="gjList.length>0">
						{{gjList[gjSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gjShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gjList"
							:key="index" @click.stop="goGjfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gjDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gjDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_57')}}：{{gjDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_58')}}：{{gjDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>

		</template>
		<template v-else>
			<div class="sqzxOne">
				<!-- @click="goClickOne(index)" -->
				<div class="sqzxOneFor" :class="itema.child.length-1 !== index?'sqzxOneForBottom':''"
					v-for="(item,index) in itema.child" :key="index">
					<div class="sqzxOneForImg">
						<img :src="item.icon" />
					</div>
					<div class="sqzxOneForName">
						{{item.title}}
					</div>
					<div class="sqzxOneForCen">
						{{item.desc}}
					</div>
					<div class="sqzxOneForXian" v-if="index!==shfwOne.length-1">
						<div></div>
					</div>
				</div>
			</div>
			<div class="fwys">
				<div class="fwysTil">{{$t('i18n_51')}}</div>
				<div class="fwysBox">
					<div class="fwysBoxFor" v-for="(item,index) in fwysList" :key="index">
						<div class="fwysBoxForImg">
							<img :src="item.cover" />
						</div>
						<div class="fwysBoxForName">
							{{item.title}}
						</div>
						<div class="fwysBoxForCen">
							{{item.desc}}
						</div>
					</div>
				</div>
			</div>
			<div class="cjfk">
				<div class="cjfkTil">
					{{$t('i18n_52')}}
				</div>
				<div class="cjfkBox">
					<div class="cjfkBoxFor" v-for="(item,index) in cjfkList" :key="index" @click="item.show=!item.show"
						:style="{
					height:item.show?'300px':'82px'
					}">
						<div class="cjfkBoxForTil">
							<div class="cjfkBoxForTilWz">{{item.question}}</div>
							<div class="cjfkBoxForTilIcon">
								<i class="el-icon-arrow-up" v-if="item.show"></i>
								<i class="el-icon-arrow-down" v-else></i>
							</div>
						</div>
						<div class="cjfkBoxForCen" v-if="item.show">
							{{item.answer}}
						</div>
					</div>
				</div>
			</div>
			<div class="gjfw">
				<div class="gjfwTil">{{$t('i18n_53')}}</div>
				<div class="gjfwXl" @click="gnShow=!gnShow">
					<div class="gjfwXlName" v-if="gnList.length>0">
						{{gnList[gnSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gnShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gnShow">
						<div class="gjfwXlDwFor" :class="gnSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gnList"
							:key="index" @click.stop="goGnfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gnDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gnDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_54')}}：{{gnDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_55')}}：{{gnDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gnDetail.cover" v-if="gnDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />

					</div>
				</div>
			</div>
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{$t('i18n_56')}}</div>
				<div class="gjfwXl" @click="gjShow=!gjShow">
					<div class="gjfwXlName" v-if="gjList.length>0">
						{{gjList[gjSel].label}}
					</div>
					<div class="gjfwXlJt" :style="gjShow?'transform: rotateX(180deg);':'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel==index?'gjfwXlDwForXz':''" v-for="(item,index) in gjList"
							:key="index" @click.stop="goGjfw(index)">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{gjDetail.title}}</div>
						<div class="gjfwDdianLeftTwo">{{gjDetail.company}}</div>
						<div class="gjfwDdianLeftThree">{{$t('i18n_57')}}：{{gjDetail.address}}</div>
						<div class="gjfwDdianLeftFour">{{$t('i18n_58')}}：{{gjDetail.phone}}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>

		</template>


	</div>
</template>

<script>
	import {
		get_int_select,
		get_int_service_network,
		get_abroad_select,
		get_abroad_service_network,
		service_advantages,
		get_question
	} from '@/api/contact.js'
	export default {
		components: {

		},
		props: {
			itema: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				shfwOne: [{
						img: require("@/assets/contact/shfw/gnsh.png"),
						name: this.$t('i18n_59'),
						cen: 'support@aohua.com'
					},
					{
						img: require("@/assets/contact/shfw/gjsh.png"),
						name: this.$t('i18n_60'),
						cen: 'customercare@aohua.com'
					},
					{
						img: require("@/assets/contact/shfw/shrx.png"),
						name: this.$t('i18n_61'),
						cen: '400-9210-114'
					},
				],
				fwysList: [
					// {
					// 	img:require('@/assets/contact/shfw/qqbz.png'),
					// 	name:'极速响应',
					// 	cen:"30分钟响应时间  24小时上门服务24小时全天在线  48小时解决问题"
					// },
					// {
					// 	img:require('@/assets/contact/shfw/qqbz.png'),
					// 	name:'高效管理',
					// 	cen:"运用C4C解决方案，高效管理用户信息 充足备品储备，让服务更人性化"
					// },
					// {
					// 	img:require('@/assets/contact/shfw/qqbz.png'),
					// 	name:'全球保障',
					// 	cen:"设立国内30+维修网点及全球 多个国家服务中心 将服务的便捷性和时效性最大化"
					// },
				],
				cjfkList: [
					// {
					// 	title:'Q:为什么插入管颜色变黄？',
					// 	cen:"A:此故障属于插入管黄色结晶。如果客户在消毒前不使用酶洗剂浸泡插入管并分解蛋白质，蛋白质与有机消毒剂之间的化学反应会导致颜色变化。",
					// 	show:false,
					// },
					// {
					// 	title:'Q:为什么插入管颜色变黄？',
					// 	cen:"A:此故障属于插入管黄色结晶。如果客户在消毒前不使用酶洗剂浸泡插入管并分解蛋白质，蛋白质与有机消毒剂之间的化学反应会导致颜色变化。",
					// 	show:false,
					// },
					// {
					// 	title:'Q:为什么插入管颜色变黄？',
					// 	cen:"A:此故障属于插入管黄色结晶。如果客户在消毒前不使用酶洗剂浸泡插入管并分解蛋白质，蛋白质与有机消毒剂之间的化学反应会导致颜色变化。",
					// 	show:false,
					// },
					// {
					// 	title:'Q:为什么插入管颜色变黄？',
					// 	cen:"A:此故障属于插入管黄色结晶。如果客户在消毒前不使用酶洗剂浸泡插入管并分解蛋白质，蛋白质与有机消毒剂之间的化学反应会导致颜色变化。",
					// 	show:false,
					// },
				],
				gnList: [
					// {
					// 	name:'总部'
					// },
					// {
					// 	name:'安徽省'
					// },
					// {
					// 	name:'北京市'
					// },
					// {
					// 	name:'上海市'
					// },
					// {
					// 	name:'四川省'
					// },
				],
				gnSel: 0,
				gnShow: false,
				gjList: [
					// {
					// 	name:'总部'
					// },
					// {
					// 	name:'安徽省'
					// },
					// {
					// 	name:'北京市'
					// },
					// {
					// 	name:'上海市'
					// },
					// {
					// 	name:'四川省'
					// },
				],
				gjSel: 0,
				gjShow: false,
				gnDetail: {},
				gjDetail: {},

			}
		},
		mounted() {
			// 获取国内下拉
			this.getSelList()
			// 获取国外下拉
			this.getGwSelList()
			// 服务优势
			this.getFwys();
			// 常见优势
			this.getCjys();
		},
		methods: {
			goGnfw(e) {
				this.gnShow = false;
				this.gnSel = e;
				this.getGnDetail();
			},
			goGjfw(e) {
				this.gjSel = e
				this.gjShow = false;
				this.getGjDetail();
			},
			getSelList() {
				let data = {}
				get_int_select(data).then(res => {
					console.log(res)
					this.gnList = res.data.list;
					this.getGnDetail();
				}).catch(err => {
					console.log(err)
				})
			},
			getGnDetail() {
				let data = {
					province_id: this.gnList[this.gnSel].value
				}
				get_int_service_network(data).then(res => {
					console.log(res)
					this.gnDetail = res.data.list.length > 0 ? res.data.list[0] : {};
				}).catch(err => {
					console.log(err)
				})
			},
			getGwSelList() {
				let data = {}
				get_abroad_select(data).then(res => {
					console.log(res)
					this.gjList = res.data.list;
					this.getGjDetail();
				}).catch(err => {
					console.log(err)
				})

			},
			getGjDetail() {
				let data = {
					country: this.gjList[this.gjSel].value
				}
				get_abroad_service_network(data).then(res => {
					console.log(res)
					this.gjDetail = res.data.list.length > 0 ? res.data.list[0] : {}
				}).catch(err => {
					console.log(err)
				})
			},
			getFwys() {
				let data = {}
				service_advantages(data).then(res => {
					console.log(res)
					this.fwysList = res.data.list;
				}).catch(err => {
					console.log(err)
				})
			},
			getCjys() {
				let data = {}
				get_question(data).then(res => {
					console.log(res)
					let list = res.data.list;
					list.forEach(v => {
						v.show = false
					})
					this.$nextTick(function() {
						this.cjfkList = list
					})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.sqzxOne {
		width: 1200px;
		margin: 0 auto;
		background: #fafafa;
		display: flex;
		justify-content: center;
		height: 400px;
		// .sqzxOneFor:first-child{
		// 	border-right: 2px solid #AFAFAF;
		// }
		position: relative;



		.sqzxOneFor {
			width: 600px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			position: relative;
			z-index: 2;

			.sqzxOneForXian {
				position: absolute;
				top: 0;
				right: 0;
				z-index: 1;
				height: 100%;
				display: flex;
				align-items: center;

				>div {
					width: 2px;
					height: 200px;
					background: #AFAFAF;
				}
			}

			.sqzxOneForImg {
				img {
					width: 120px;
					height: 120px;
				}
			}

			.sqzxOneForName {
				font-size: 35px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-top: 30px;
			}

			.sqzxOneForCen {
				margin-top: 16px;
				font-size: 23px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}
		}
	}

	.fwys {
		width: 1200px;
		margin: 0 auto;
		margin-top: 117px;

		.fwysTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 31px;
		}

		.fwysBox {
			display: flex;
			align-items: center;
			width: 100%;
			margin-bottom: 107px;

			.fwysBoxFor:not(:last-child) {
				margin-right: 15px;
			}

			.fwysBoxFor {
				width: 390px;
				background: #F8F8F8;
				border-radius: 20px;
				border-radius: 20px;

				.fwysBoxForImg {
					img {
						width: 390px;
						height: 358px;
						border-radius: 20px 20px 0 0;
						object-fit: cover;
					}
				}

				.fwysBoxForName {
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #000000;
					margin-left: 17px;
					padding-top: 43px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.fwysBoxForCen {
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #909090;
					margin-top: 19px;
					margin-left: 17px;
					margin-right: 17px;
					margin-bottom: 43px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					// 必须加不然隐藏不了
					/*! autoprefixer: ignore next */
					-webkit-box-orient: vertical;
				}
			}
		}
	}

	.cjfk {
		width: 1200px;
		margin: 0 auto;

		.cjfkTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 57px;
		}

		.cjfkBox {
			display: flex;
			flex-wrap: wrap;

			.cjfkBoxFor:nth-of-type(2n) {
				margin-left: 2%;
			}

			.cjfkBoxFor {
				cursor: pointer;
				width: 49%;
				padding: 24px 38px;
				box-sizing: border-box;
				background-color: #f7f7f7;
				margin-bottom: 16px;
				border-radius: 10px;

				.cjfkBoxForTil {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.cjfkBoxForTil {
						font-size: 24px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #7E7E7E;
					}

					.cjfkBoxForTilIcon {
						font-size: 26px;
					}
				}

				.cjfkBoxForCen {
					margin-top: 31px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #666666;
					height: 180px;
					overflow-y: auto;
				}
			}
		}
	}

	.gjfw {
		width: 1200px;
		margin: 0 auto;
		margin-top: 117px;
		padding-bottom: 95px;

		.gjfwTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 96px;
		}

		.gjfwXl {
			width: 400px;
			padding-bottom: 18px;
			margin-bottom: 43px;
			border-bottom: 2px solid #ADADAD;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;

			.gjfwXlName {
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}

			.gjfwXlJt {
				img {
					width: 35px;
					height: 20px;
				}
			}

			.gjfwXlDw {
				position: absolute;
				bottom: -200px;
				left: 0;
				width: 100%;
				height: 182px;
				background: #FFFFFF;
				box-shadow: 0px 1px 6px 0px rgba(39, 39, 39, 0.2);
				border-radius: 10px;
				overflow-y: auto;
				padding: 10px 30px;
				box-sizing: border-box;

				.gjfwXlDwFor {
					// font-size: 24px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					height: 40px;
					display: flex;
					align-items: center;
				}

				.gjfwXlDwForXz {
					color: #1A2588;
				}
			}
		}

		.gjfwDdian {
			display: flex;
			align-items: center;
			width: 1200px;
			height: 400px;
			background: #fafafa;
			padding: 48px 128px;
			box-sizing: border-box;

			.gjfwDdianLeft {
				flex: 1;
				width: 0;
				height: 100%;
				display: flex;
				flex-direction: column;

				.gjfwDdianLeftOne {
					// font-size: 36px;
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #6A6A6A;
					flex: 1;
				}

				.gjfwDdianLeftTwo {
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
					margin-bottom: 35px;
				}

				.gjfwDdianLeftThree {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
					margin-bottom: 23px;
				}

				.gjfwDdianLeftFour {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #4C4C4C;
				}
			}

			.gjfwDdianRight {
				margin-left: 30px;

				img {
					width: 400px;
					height: 305px;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.sqzxOne {
			width: 100% !important;
			// background: red !important;
			display: block !important;
			height: auto !important;

			.sqzxOneForBottom {
				border-bottom: 2px solid #eeeeee;
			}

			.sqzxOneFor {
				width: 100% !important;
				padding-bottom: 10px !important;
				box-sizing: border-box;

				.sqzxOneForName {
					// margin-top: 10px !important;
					font-size: 20px !important;
				}

				.sqzxOneForCen {
					font-size: 18px !important;
				}

				.sqzxOneForXian {
					display: none;
				}
			}
		}

		.fwys {
			width: 100% !important;
			// background: greenyellow !important;
			display: block !important;
			margin-top: 10px !important;

			.fwysTil {
				font-size: 28px !important;
				padding-left: 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 15px !important;
			}

			.fwysBox {
				display: block !important;
				padding: 0 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 0 !important;
			}

			.fwysBoxFor {
				width: 100% !important;
				margin: 0 !important;
				padding: 15px !important;
				box-sizing: border-box !important;
				margin-bottom: 10px !important;

				.fwysBoxForImg {
					width: 100% !important;
					height: auto !important;

					img {
						width: 100% !important;
						height: auto !important;
					}
				}

				.fwysBoxForName {
					margin: 10px 0 !important;
					padding: 0 !important;
					font-size: 26px !important;
				}

				.fwysBoxForCen {
					margin: 0 !important;
				}
			}
		}

		.cjfk {
			width: 100% !important;
			// background: paleturquoise !important;
			margin-top: 10px !important;

			.cjfkTil {
				font-size: 28px !important;
				padding-left: 30px !important;
				box-sizing: border-box !important;
				margin-bottom: 15px !important;
			}

			.cjfkBox {
				display: block !important;
				padding: 0 30px !important;
				box-sizing: border-box !important;

				.cjfkBoxFor {
					width: 100% !important;
					margin: 0 !important;
					margin-bottom: 10px !important;
				}
			}
		}

		.gjfw {
			width: 100% !important;
			// background-color: green;
			margin-top: 10px !important;
			height: auto !important;
			padding: 0 30px !important;
			box-sizing: border-box !important;

			.gjfwTil {
				font-size: 28px !important;
				margin-bottom: 10px !important;
			}

			.gjfwXl {
				width: 100% !important;
				margin-bottom: 0 !important;

				.gjfwXlName {
					font-size: 20px !important;
				}

				.gjfwXlJt {
					img {
						width: 20px !important;
						height: 10px !important;
					}
				}
			}
		}
		.gjfwDdian {
			width: 100% !important;
			// background-color: pink !important;
			padding: 0 !important;
			height: auto !important; 
			display: block !important; 
			margin-top: 10px !important;
			.gjfwDdianLeft{
				height: auto !important;
				width: 100% !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				.gjfwDdianLeftOne{
					height: auto !important; 
					font-size: 25px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftTwo{
					font-size: 20px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftThree{
					font-size: 14px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftFour{
					font-size: 14px !important;
				}
			}
		
			.gjfwDdianRight {
				width: 100%;
				margin: 0 !important;
				margin-top: 10px !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				img {
					width: 100% !important;
					height: auto !important;
				}
			}
		}
	}
</style>